
import React from 'react';

const OptionColumn = ({title,description,children,panel,cols}) => (
    <div className="row">
        <div className={`col-sm-${cols ? cols.left:'3'} col-description`}>
            <div className="title">{title}</div>
            <div className="description">{description}</div>
        </div>
        <div className={`col-sm-${cols ? cols.right:'9'} inherit-position`}>
            {
                panel === false ?
                    children
                    :
                <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                    <div className="panel-body">
                        {children}
                    </div>
                </div>
            }
        </div>
    </div>
);

export default OptionColumn;




// WEBPACK FOOTER //
// ./components/general/OptionColumn.js